import { de, enUS } from 'date-fns/locale';
import i18n from 'i18next';

const DATE_FNS_LOCALES = {
  en: enUS,
  de,
};
export const calendarLocale =
  DATE_FNS_LOCALES[i18n.language as keyof typeof DATE_FNS_LOCALES] ?? de;
